<template>
    <el-dialog
        :visible="dialogVisible"
        @close="handleCloseDialog"
        width="70%"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <el-table
            :data="order_month"
            tooltip-effect="dark">
            <!-- 订单号 -->
            <el-table-column
                :label="$t('message.corder.table1')"
                prop="order_sn"
                align="center"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 部门 -->
            <el-table-column
                :label="$t('message.corder.table2')"
                prop="departmentname"
                align="center"
                show-overflow-tooltip
                v-if="!power.includes(111)">
            </el-table-column>
            <!-- 子公司/分行 -->
            <el-table-column
                :label="$t('message.corder.table3')"
                prop="branchname"
                align="center"
                show-overflow-tooltip
                v-if="!power.includes(111)">
            </el-table-column>
            <!-- 打单员 -->
            <el-table-column
                :label="$t('message.corder.table4')"
                prop="userID"
                align="center"
                show-overflow-tooltip
                v-if="!power.includes(111)">
            </el-table-column>
            <!-- 金额 -->
            <el-table-column
                :label="$t('message.corder.table5')"
                prop="order_amount"
                align="center"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 状态 -->
            <el-table-column 
                :label="$t('message.costatus.table6')"
                align="center">
                <template v-slot="{row}">
                    <div v-if="row.status!=null && row.order_status==0">
                        {{{val:row.status,lang:$t("message.costatus")} | status}}
                    </div>
                    <div v-else-if="row.pay_status">
                        {{{val:row.pay_status,lang:$t("message.costatus")} | pay_status}}
                    </div>
                    <div v-else>
                        {{{val:row.order_status,lang:$t("message.costatus")} | orstatus}}
                    </div>
                </template>
            </el-table-column>
        </el-table>
		<div style="margin-top: 10px; display: flex;justify-content: flex-end;">
			<el-pagination
				current-change
			    @size-change="handleSizeChange"
			    @current-change="handleCurrentChange"
			    :current-page="1"
			    :page-size="order_month_page.per_page"
			    layout="prev, pager, next, jumper"
			    :total="order_month_page.total">
			  </el-pagination>
		</div>
    </el-dialog>
</template>

<script>
import { mapState, mapMutations ,mapActions} from 'vuex'
import { OrderFilters } from '@/utils/orderFilters.js'

export default {
    mixins: [ OrderFilters ],
    computed: mapState({
        dialogVisible: state => state.dialogVisible,
        order_month: state => state.order.order_month,
		month: state => state.order.month,
		order_month_page: state => state.order.order_month_page,
        power: state => state.user.power
    }),
	data() {
	      return {
	        currentPage: 1
	      };
	},
    methods: {
        ...mapMutations([
            "handleDialog",
            "setOrderMonth"
        ]),
		...mapActions([
		    "getOrderMonth"
		]),
		handleOpen(month,page){
		    this.getOrderMonth({
				page,
		        month,
		        order_sn: sessionStorage.getItem('order_sn') || '',
		        department_id: sessionStorage.getItem('department_id') || '',
		        user_id: sessionStorage.getItem('user_id') || '',
		        release: sessionStorage.getItem('release') || '',
		        relend: sessionStorage.getItem('relend') || ''
		    })
		},
		handleSizeChange(res){
			// console.log(res,1)
			this.handleOpen(this.month,res)
			
		},
		// 每页条数
		handleCurrentChange(res){
			this.currentPage = res
			// console.log(res,2)
			this.handleOpen(this.month,res)
		},
		// 改变时会触发
        handleCloseDialog(){
            this.handleDialog(false);
            this.setOrderMonth([]);
        }
    },
}
</script>

<style scoped>

</style>
